import { render, staticRenderFns } from "./ActorForm.vue?vue&type=template&id=1461a2ce&scoped=true&"
import script from "./ActorForm.vue?vue&type=script&lang=js&"
export * from "./ActorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461a2ce",
  null
  
)

export default component.exports